import React, { useEffect } from 'react';
import { getScrollPercent } from './scrollUtils';
import { useTimer } from '../../hooks/useTimer';

export function CampaignOnScroll({
	displayTimer,
	onScrollMatch,
	scrollPercentage,
	children,
}: {
	displayTimer: number | null;
	onScrollMatch: () => void;
	scrollPercentage: number;
	children: React.ReactElement;
}): JSX.Element {
	function onScroll() {
		const currentPercentage = getScrollPercent();

		if (currentPercentage >= scrollPercentage) {
			onScrollMatch();
			window.removeEventListener('scroll', onScroll);
		}
	}

	function onTimerFinished() {
		window.addEventListener('scroll', onScroll);

		// NOTE: This is to trigger the scroll event immediately when the timer is finished
		const scrollEvent = new Event('scroll');
		window.dispatchEvent(scrollEvent);
	}

	useEffect(() => () => window.removeEventListener('scroll', onScroll), []);

	useTimer(onTimerFinished, displayTimer);

	return children;
}
